import { useEffect } from 'react'
import { motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'
import { PiLink } from 'react-icons/pi'

import ButtonLink from '@components/common/Button/ButtonLink'
import ProgressBar from '@components/common/ProgressBar/ProgressBar'
import HeaderBack from '@/components/dashboard/Header/HeaderBack'

import MotionText from '@/components/common/Motion/MotionText'
import { usePageSetup } from '@/hooks/usePageSetup'

import { useKycStore } from '@store/useKycStore'

import { VAT_HOW_PDF } from '../Profile/ProfilePage'

export const KycVatPage = () => {
  const { t } = useTranslation()
  usePageSetup(t('kyc.pageTitle.vat'), { scroll: true })

  const progress = useKycStore((state) => state.progress)
  const setProgress = useKycStore((state) => state.setProgress)

  useEffect(() => setProgress(5), [])

  return (
    <div className="h-full bg-white p-5 pb-8 flex flex-col">
      <HeaderBack className='items-center gap-4'>
        <ProgressBar
          currentStep={progress}
          totalSteps={8}
        />
      </HeaderBack>

      <div className="flex-1 flex flex-col mt-4">
        <div className="space-y-4">
          <MotionText
            as="h2"
            className="text-zinc-900 text-3xl font-bold leading-tight"
            delay={0.2}
          >
            {t('kyc.vat.title')}
          </MotionText>
          <MotionText
            as="p"
            className="text-zinc-700 text-base"
            delay={0.4}
          >
            {t('kyc.vat.description')}
          </MotionText>
        </div>
      </div>

      <motion.div className="space-y-4 flex flex-col">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='primary' to={'/kyc/insurance-status'}>
            {t('kyc.vat.yesRegistered')}
          </ButtonLink>
        </motion.div>
        <ButtonLink variant='secondary' to={VAT_HOW_PDF} target='_blank'>
          <motion.span
            className='flex justify-center items-center gap-1'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.2,
              ease: "easeOut"
            }}
          >
            {t('kyc.vat.howToRegister')}
            <PiLink className='w-4 h-4' />
          </motion.span>
        </ButtonLink>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{
            duration: 0.2,
            ease: "easeOut"
          }}
        >
          <ButtonLink variant='tertiary' to={'/kyc/insurance-status'}>
            {t('kyc.vat.doLater')}
          </ButtonLink>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default KycVatPage